import appConfig from 'appConfig';

import { getToken } from 'ConnectionManager/sessionManager';
import CoursewareItemProvider from '../coursewareItem/CoursewareItemProvider';


export default class ClassService {
  constructor({ id }) {
    this.id = id;
  }

  getCohort() {
    const { piSession } = window;
    const { cohortId, deploymentId } = CoursewareItemProvider.getDeploymentContext();
    const productId = CoursewareItemProvider.getProductId();

    const piToken = getToken();
    const piUserId = piSession.userId();

    return {
      cohortId,
      deploymentId,
      url: appConfig.getCSGURL(),
      piToken,
      piUserId,
      productId,
      env: appConfig.getEnv(),
    };
  }

  static build(args) {
    return new ClassService(args);
  }
}
